import { createContext } from 'react';

const RFIsContext = createContext();
const RFIsRouterContext = createContext();

export { RFIsRouterContext, RFIsContext };
export default RFIsContext;
